let CryptoJS = require("crypto-js");
let crypto_crendentials = { secretKey: "ishield.aiSECRET" };

function convertSecretToBytes(params) {
    let myBuffer = [];
    let encoder = new TextEncoder();
    let buffer = encoder.encode(params);
    for (let val = 0; val < buffer.length; val++) {
        myBuffer.push(buffer[val]);
    }

    return myBuffer;
}

function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('')
}

let secret_in_bytes = convertSecretToBytes(crypto_crendentials.secretKey);
let secret_in_hex = toHexString(secret_in_bytes);

function encryptObject(data) {
    try {
        let enc = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            CryptoJS.enc.Hex.parse(secret_in_hex),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        )

        return { data: enc.ciphertext.toString()}
    } catch (error) {
        // Handle encryption error
    }
}

function decryptObject(encrypted_string) {
    try {
        let bytes = CryptoJS.AES.decrypt(
            CryptoJS.format.Hex.parse(encrypted_string),
            CryptoJS.enc.Hex.parse(secret_in_hex),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        let decryptedData = CryptoJS.enc.Utf8.stringify(bytes);

        return { data: decryptedData}
    } catch (error) {
        // Handle decryption error
    }
}

module.exports = {
    encryptObject,
    decryptObject
}
